import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { deleteToken, getMessaging, getToken, isSupported } from 'firebase/messaging';

import AppLogger from 'utils/AppLogger';

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID,
	appId: import.meta.env.VITE_FIREBASE_APPID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENTID
};

let messaging;
const firebaseApp = initializeApp(firebaseConfig);

isSupported().then((supported) => {
	if (supported) {
		messaging = getMessaging(firebaseApp);
	}
});

export const deleteFCMToken = async () => {
	if (!messaging) return;
	await deleteToken(messaging);
};

export const fetchToken = async () => {
	if (!messaging) return null;
	try {
		const swRegistration = await navigator.serviceWorker.register(
			`/firebase-messaging-worker.js?firebaseConfig=${encodeURIComponent(JSON.stringify(firebaseConfig))}`
		);
		return await getToken(messaging, {
			serviceWorkerRegistration: swRegistration
		});
	} catch (error) {
		AppLogger.log('An error occurred while retrieving fcm token. ', error);
		return null;
	}
};

// Reference to the firebase auth service
export const auth = getAuth(firebaseApp);
